import React from 'react';
import PropTypes from 'prop-types';
import {Banner, Button, Dialogue, Text, Icon} from '@albert-io/atomic';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

import '../invite-by-email.scss';

const IBESummary = ({
  handleClose,
  onBackBtnClick,
  rejectedInvitations,
  hardCapRejectedInvitations,
  fulfilledInvitations,
  ...rest
}) => {
  return (
    <Dialogue handleClose={handleClose} title='Confirmation' {...rest}>
      <Dialogue.Body>
        {fulfilledInvitations.length !== 0 && (
          <div className='flex flex-col gap-x1 overflow-y-auto p-x2'>
            {fulfilledInvitations.map((email) => (
              <div className='flex w-full justify-between'>
                <Text className='overflow-hidden text-left text-ellipsis whitespace-nowrap'>
                  {email}
                </Text>
                <div className='ibe-center-padding mx-x1' />
                <div className='flex items-center'>
                  <Text className='mr-x1 whitespace-nowrap content-positive'>Invited</Text>
                  <Icon icon='check' color='inherit' className='content-positive' />
                </div>
              </div>
            ))}
          </div>
        )}
        {hardCapRejectedInvitations.length !== 0 && (
          <>
            <HardCapWarningBanner seatsRemaining={0} rounded className='my-x1' />
            <div className='flex flex-col gap-x1 overflow-y-auto p-x2'>
              {hardCapRejectedInvitations.map((email) => (
                <div className='flex w-full justify-between'>
                  <Text className='overflow-hidden text-left text-ellipsis whitespace-nowrap'>
                    {email}
                  </Text>
                  <div className='ibe-center-padding mx-x1' />
                  <div className='flex items-center'>
                    <Text color='negative' className='mr-x1 whitespace-nowrap'>
                      Not invited
                    </Text>
                    <Icon icon='xmark' color='inherit' className='content-negative' />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {rejectedInvitations.length !== 0 && (
          <>
            <Banner type='negative' className='mb-x2' dismissable={false} border={false}>
              We encountered a problem sending invitations to the following recipients. Please try
              again:
            </Banner>
            <div className='flex flex-col gap-x1 overflow-y-auto p-x2'>
              {rejectedInvitations.map((email) => (
                <div className='flex w-full justify-between'>
                  <Text className='overflow-hidden text-left text-ellipsis whitespace-nowrap'>
                    {email}
                  </Text>
                  <div className='ibe-center-padding mx-x1' />
                  <div className='flex items-center'>
                    <Text color='negative' className='mr-x1 whitespace-nowrap'>
                      Not invited
                    </Text>
                    <Icon icon='xmark' color='inherit' className='content-negative' />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </Dialogue.Body>
      <Dialogue.BtnGroup>
        <Button color='secondary' onClick={onBackBtnClick}>
          Back
        </Button>
        <Button onClick={handleClose}>Finish</Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

IBESummary.propTypes = {
  handleClose: PropTypes.func,
  onBackBtnClick: PropTypes.func,
  rejectedInvitations: PropTypes.arrayOf(PropTypes.string),
  fulfilledInvitations: PropTypes.arrayOf(PropTypes.string),
  hardCapRejectedInvitations: PropTypes.arrayOf(PropTypes.string)
};

export default IBESummary;
